var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-wrap" }, [
    _vm._m(0),
    _c("div", { staticClass: "login-right" }, [
      _c(
        "div",
        { staticClass: "login-right-content" },
        [
          _c("img", {
            staticClass: "login-right-img",
            attrs: { src: require("@/assets/kkwslogo.png"), alt: "" }
          }),
          _c(
            "el-form",
            {
              ref: "loginForm",
              staticClass: "ms-content",
              attrs: {
                model: _vm.loginForm,
                rules: _vm.loginRules,
                "auto-complete": "on",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "username" } },
                [
                  _c("span", { staticClass: "svg-container" }, [
                    _vm._v(" 用户ID ")
                  ]),
                  _c("el-input", {
                    ref: "username",
                    attrs: {
                      id: "loginUserName",
                      placeholder: "请输入用户ID",
                      name: "username",
                      type: "text",
                      tabindex: "1",
                      "auto-complete": "on"
                    },
                    model: {
                      value: _vm.loginForm.username,
                      callback: function($$v) {
                        _vm.$set(_vm.loginForm, "username", $$v)
                      },
                      expression: "loginForm.username"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "password" } },
                [
                  _c("span", { staticClass: "svg-container" }, [
                    _vm._v(" 密码 ")
                  ]),
                  _c("el-input", {
                    key: _vm.passwordType,
                    ref: "password",
                    attrs: {
                      id: "loginPassword",
                      type: _vm.passwordType,
                      placeholder: "请输入密码",
                      name: "password",
                      tabindex: "2",
                      "auto-complete": "on"
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleLogin($event)
                      }
                    },
                    model: {
                      value: _vm.loginForm.password,
                      callback: function($$v) {
                        _vm.$set(_vm.loginForm, "password", $$v)
                      },
                      expression: "loginForm.password"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticStyle: {
                    width: "100%",
                    "margin-bottom": "30px",
                    background: "var(--mainColor)",
                    border: "0"
                  },
                  attrs: {
                    loading: _vm.loading,
                    id: "loginBtn",
                    type: "primary"
                  },
                  nativeOn: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.handleLogin($event)
                    }
                  }
                },
                [_vm._v("登录")]
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-left" }, [
      _c("div", { staticClass: "login-left-img" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }